import { request } from "@/utils/request";

/**
 * 查询
 * @param {*} data
 * @returns
 */
export function selectApi(data) {
  return request({
    url: `/admin/sysPrompt/select`,
    method: "POST",
    data,
  });
}

/**
 * 更改
 * @param {*} data
 * @returns
 */
export function updateApi(data) {
  return request({
    url: `/admin/sysPrompt/update`,
    method: "POST",
    data,
  });
}


/**
 * 删除
 * @param {*} data
 * @returns
 */
export function deleteApi(data) {
  return request({
    url: `/admin/sysPrompt/delete`,
    method: "POST",
    data,
  });
}
